import { useRef, useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Spinner } from 'flowbite-react';
import { toast } from 'react-toastify';

import PageHead from 'components/PageHead';
import PostList from 'components/PostList';
import { PostEditor } from 'components/Editor';

import request from 'utils/https-request';

function Edit() {
  const navigate = useNavigate();
  const editorRef = useRef();
  const { postID } = useParams();
  const [isSending, setIsSending] = useState(false);
  const [writer, setWriter] = useState();

  const { register, handleSubmit, setValue } = useForm();

  const onPasswordChange = event => {
    setValue(event.target.name, event.target.value.replace(/[^0-9]/g, ''));
  };

  const onSubmit = async data => {
    data.content = editorRef.current.getContents();

    setIsSending(true);
    if (data.title.length === 0) {
      toast.error('제목을 입력해주세요');
      setIsSending(false);
    } else if (editorRef.current.getCharCount() === 0) {
      toast.error('내용을 입력해주세요');
      setIsSending(false);
    } else if (data.content.length > 16380) {
      toast.error('최대 글자수를 초과하였습니다.');
      setIsSending(false);
    } else if (data.password.length === 0) {
      toast.error('비밀번호를 입력해주세요');
      setIsSending(false);
    } else if (data.password.length !== 6) {
      toast.error('비밀번호 6자리를 입력해주세요');
      setIsSending(false);
    } else {
      const response = await request({
        url: `/post/${postID}`,
        method: 'PUT',
        data: data,
      });
      if (response.success) {
        setIsSending(false);
        navigate(`/board/${postID}`);
      } else if (response.code === 403) {
        toast.error('비밀번호가 틀렸습니다');
        setIsSending(false);
      }
    }
  };

  const getContents = async () => {
    const response = await request({
      method: 'GET',
      url: `/post/${postID}`,
    });

    if (response && response.success) {
      setValue('title', response.data.title);
      setWriter(response.data.writer);
      editorRef.current.core.setContents(response.data.content);
    } else {
      navigate('/board');
      toast.error('잘못된 접근이 감지되었습니다');
    }
  };

  useEffect(() => {
    getContents();
  }, [postID]);

  return (
    <div className="pb-20">
      <PageHead>게시판</PageHead>
      <form className="content-xl space-y-3" onSubmit={handleSubmit(onSubmit)}>
        <input
          {...register('title')}
          className="w-full border px-4 py-2 text-xl placeholder:text-slate-400 focus:outline-none"
          placeholder="제목"
          maxLength="43"
        />

        <div className="border">
          <PostEditor ref={editorRef} />
        </div>

        <div className="flex items-center border px-4 py-2">
          <label className="text-xl">글쓴이 :</label>
          <div className="mr-4 w-40 px-4 py-2 text-xl">{writer}</div>
          <label className="text-xl">비밀번호</label>
          <input
            {...register('password')}
            className="number-password ml-2 mr-4 w-24 border px-4 py-2 text-xl placeholder:text-slate-400 focus:outline-none"
            name="password"
            placeholder="6자리"
            maxLength="6"
            type="password"
            inputMode="numeric"
            autoComplete="off"
            onChange={onPasswordChange}
          />
        </div>
        <div className="ml-auto w-fit text-xl font-semibold text-gray-400 hover:text-black">
          {isSending ? (
            <Spinner className="mr-2 cursor-pointer" />
          ) : (
            <button type="submit">수정</button>
          )}
        </div>
      </form>
      <PostList />
    </div>
  );
}

export default Edit;
